import {
  Box,
  Button,
  Card,
  CardMedia,
  Checkbox,
  CircularProgress,
  Container,
  Divider,
  FormControlLabel,
  Grid,
  Link,
  Radio,
  RadioGroup,
  Skeleton,
  Stack,
  styled,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import {
  addDoc,
  collection,
  doc,
  Firestore,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import React, { useEffect } from "react";
import { db, functions } from "../../firebase.config";
import CustomButton from "../CustomButton";
import EventCard from "../EventCard";
import Iconify from "../Iconify";
import { PayWithPayD } from "../paiement/PayWithPaydunya";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Timer from "./Timer";
import { UserAuth } from "../../context/AuthContext";
import Modal from "@mui/material/Modal/Modal";
import Backdrop from "@mui/material/Backdrop/Backdrop";
import Fade from "@mui/material/Fade/Fade";
import { httpsCallable } from "firebase/functions";
import { Sheet } from 'react-modal-sheet';
import { checkPromoCode, goToPayWidget, initiatePay } from "../api/api";
import { shortNumber } from "../util/formatNumber";
import Cookies from "js-cookie";
import CustomTextField from "../customTextfield";


var paydunya = require("paydunya");

/*function payWithPaydunya(btn) {
  payWithPaydunya
    .setup({
      selector: btn,
      url: "https://choptonticket/paydunya-api",
      method: "GET",
      displayMode: payWithPaydunya.DISPLAY_IN_POPUP,
      beforeRequest: function () {
        console.log("About to get a token and the url");
      },
      onSuccess: function (token) {
        console.log("Token: " + token);
      },
      onTerminate: function (ref, token, status) {
        console.log(ref);
        console.log(token);
        console.log(status);
      },
      onError: function (error) {
        alert("Unknown Error ==> ", error.toString());
      },
      onUnsuccessfulResponse: function (jsonResponse) {
        console.log("Unsuccessful response ==> " + jsonResponse);
      },
      onClose: function () {
        console.log("Close");
      },
    })
    .requestToken();
}*/

var setup = new paydunya.Setup({
  masterKey: "DNrUjYFV-6HiQ-NNu5-DAgU-WizSswjzZW6I",
  privateKey: "test_private_Qyqe0MaokWBMmU1m5d1kNHcj7fs",
  publicKey: "test_public_8FAyuNRDgwV2v8Yujc8QHvlYtuS",
  token: "vT8PF5dQR3zx7r9OcplJ",
  mode: "test",
  cancelURL: "http://localhost:5000/",
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
};
const styleRecap = {
  position: "absolute",
  top: "0",
  left: "0",
  width: "100%",
  height: "100%",
  bgcolor: "background.paper",
  p: 2,
};

export default function ReserMobile2({ event, montant, ticketsList, seance, widget, config }) {
  const { user } = UserAuth();
  const { eventID } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [loadingF, setLoadingF] = React.useState(false);
  const [total, setTotal] = React.useState(montant);
  const [check, setCheck] = React.useState(false);
  const [nomField, setNom] = React.useState("");
  const [prenomField, setPrenom] = React.useState("");
  const [emailField, setEmail] = React.useState("");
  const [confirmEmailField, setConfirmEmail] = React.useState("");
  const [discountField, setDiscount] = React.useState("");
  const [reduction, setReduction] = React.useState();
  const [addCode, setAddCode] = React.useState(false);
  const [codeCheck, setCodeCheck] = React.useState({});
  const [fieldError, setError] = React.useState(false);
  const [confirmError, setConfirmError] = React.useState(false);
  const [fee, setFee] = React.useState(0);
  const [moyenPaie, setMoyenpaie] = React.useState(0);

  const handleRadioChange = (event) => {
    var tmp = event.target.value;
    if (parseInt(tmp) === 0) {
      setFee(0)
    } else if (parseInt(tmp) === 1) {
      setFee(1.5)
    } else {
      setFee(2.5)
    }
    setMoyenpaie(parseInt(event.target.value));
  };
  const setPaymentWay = (value) => {
    var tmp = value;
    if (parseInt(tmp) === 0) {
      setFee(0)
    } else if (parseInt(tmp) === 1) {
      setFee(1.5)
    } else {
      setFee(2.5)
    }
    setMoyenpaie(parseInt(value));
  };

  useEffect(() => {
    (async () => {
      try {
        setLoadingF(true);
        const docRef0 = doc(db, "users", user.uid);
        const docSnap = await getDoc(docRef0);
        if (docSnap.exists()) {
          setEmail(docSnap.data().email);
          setNom(docSnap.data().nom);
          setPrenom(docSnap.data().prenom);
          setConfirmEmail(docSnap.data().email);
          console.log("start");
          // setLoading(false);
        } else {
          const docRef0 = doc(db, "organisateurs", user.uid);
          const docSnap = await getDoc(docRef0);
          if (docSnap.exists()) {
            setEmail(docSnap.data().email);
            setConfirmEmail(docSnap.data().email);
            setNom(docSnap.data().nom);
            setPrenom(docSnap.data().prenom);

            // setLoading(false);
          }
        }
      } catch (error) {
        console.log(error);
      }
      setLoadingF(false);
    })();
  }, [user]);

  //Creation de la facture
  //fonction de paiement
  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
    return null;
  }
  const getLocationFromCookies = () => {
    const location = Cookies.get("userLocation");
    return location ? JSON.parse(location) : null;
  };
  //fonction de paiement
  const payV2 = async () => {
    setLoading(true);
    var montant = 0;
    if (nomField === "" || prenomField === "" || emailField === "") {
      setError(true);
      setLoading(false);
      return;
    }
    if (emailField !== confirmEmailField) {
      setConfirmError(true);
      setLoading(false);
      return;
    }
    if (config?.devMode) {
      setLoading(false);
      return
    }
    const affiliate = getCookie(`affId-${eventID}`);
    const location = getLocationFromCookies();
    const source = 'Direct'
    
    try {
      console.log()
      const payload = {
        uid: user?.uid,
        tickets: ticketsList,
        firstname: prenomField,
        lastname: nomField,
        mobile: "",
        email: emailField,
        eventid: eventID,
        from: 1,
        discount: reduction,   // ton objet promo
        fee,
        seance,
        track: affiliate,       // tracking affilié
        location,
        source,
        version: 1
      };

      const response = await fetch('https://us-central1-event-86cbf.cloudfunctions.net/initiatePayV2', {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
      console.log(data)

      // 🔥 Important : il faut le await ici !!!
      /* const result = await initiatePay(payload);
      console.log("-----------------result payment----------------")
      console.log(result.data)
      if (result.data?.status === 'ok') {
        const url = result.data.link; // "/fr/event/12345"
        const parts = url.split("/"); // ["", "fr", "event", "12345 
        const billId = parts[parts.length - 1];
        console.log('facture')
        console.log(billId)
        Cookies.set(`billId`, billId, { expires: 1 });
        window.location.href = result.data.link
      } else {
        setLoading(false);
        //window.location.replace(`http://localhost:3001/fr/event/${eventID}?order=unavalable`)
        // window.location.replace(`https://choptonticket.com/fr/event/${eventID}?order=unavalable`)
        // navigate(`/fr/event/${eventID}?stateOrder=unavalable`)

      } */
    } catch (error) {
      console.log(error)
      setLoading(false);
    }
  };
  const pay = async () => {
    setLoading(true);

    if (nomField === "" || prenomField === "" || emailField === "") {
      setError(true);
      setLoading(false);
      return;
    }
    if (emailField !== confirmEmailField) {
      setConfirmError(true);
      setLoading(false);
      return;
    }

    if (config.devMode) {
      setLoading(false);
      return
    }
    const affiliate = getCookie(`affId-${eventID}`);
    const location = getLocationFromCookies();
    const source = 'Direct';

    try {
      const addMessage = httpsCallable(functions, "initiatePay");
      const result = await addMessage({
        tickets: ticketsList,
        uid: user ? user.uid : null,
        firstname: prenomField,
        lastname: nomField,
        mobile: '',
        email: emailField,
        eventid: eventID,
        from: widget ? 0 : 1,
        discount: reduction,
        fee: fee,
        seance: seance,
        track: affiliate ? { aff: affiliate } : null,
        location: location,
        source: source,
      });

      if (result.data?.status === 'ok') {
        const url = result.data.link;
        const parts = url.split("/");
        console.log(parts)
        const billId = parts[parts.length - 1];
        Cookies.set(`billId`, billId, { expires: 1 });
        if (parts[2] === 'choptonticket.com') {

          if (widget) {
            window.location.href = `/fr/checkout_embed/${parts[5]}/confirmation`;
          } else {
            window.location.href = result.data.link;
          }
          return
        }
        if (widget) {
          // Redirection via <a> simulé
          const link = document.createElement("a");
          link.href = result.data.link;
          link.target = "_blank"; // "_self" si tu veux l'ouvrir dans l'iframe
          link.rel = "noopener noreferrer";
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          navigate(`waiting/${billId}`)
        } else {
          window.location.href = result.data.link;
        }

      } else {
        setLoading(false);
        window.location.replace(`https://choptonticket.com/fr/event/${eventID}?order=unavalable`);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };


  const [procedCheckCP, setProcedCheckCP] = React.useState(false);
  const handleVerifyPromoCode = async () => {
    let response
    try {
      setLoading(true)
      setProcedCheckCP(true)
      response = await checkPromoCode(eventID, discountField, ticketsList,);
      console.log(response.discount)
      setReduction(response.discount);
      setCodeCheck({ valid: true, message: response.message, })

    } catch (error) {
      setCodeCheck({ valid: false, message: 'code non valide ou expiré', })
    } finally {
      setLoading(false)
      setProcedCheckCP(false)
    }

  };

  const hexToRgba = (hex, opacity) => {
    const bigint = parseInt(hex.replace('#', ''), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  function getContrastColor(hex) {
    const color = hex.replace("#", "");
    const r = parseInt(color.substring(0, 2), 16);
    const g = parseInt(color.substring(2, 4), 16);
    const b = parseInt(color.substring(4, 6), 16);

    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    return brightness < 128 ? "#FFFFFF" : "#000000";
  }

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  /** recapitulatif modal */
  const [openRecap, setOpenRecap] = React.useState(false);
  const handleOpenRecap = () => setOpenRecap(true);
  const handleCloseRecap = () => setOpenRecap(false);
  const [searchParams] = useSearchParams();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {loadingF ? (
        <Stack paddingY={10}>
          <CircularProgress size={80} sx={{ color: "#5E17EB" }} />
        </Stack>
      ) : (
        <Box
          sx={{
            bgcolor: `${config?.color != null ? `#${config?.color?.bgColor}` : 'white'}`, color: `#${config?.color?.textColor}`
          }}
        >




          <Stack spacing={5} paddingX={2} paddingY={4} sx={{ overflowX: "auto", overflowY: "auto", height: 'calc(100vh - 80px)', bgcolor: `${config?.color != null ? `#${config?.color?.bgColor}` : 'white'}`, color: `#${config?.color?.textColor}` }}>
            {/** information billing */}
            <Stack spacing={2}>
              <Typography
                fontSize={18}
                fontWeight={500}
              >
                Informations de facturation
              </Typography>
              <Stack direction={'row'} spacing={2}>

                <CustomTextField
                  disabled={loading}
                  value={nomField}
                  onChange={(e) => setNom(e.target.value)}
                  fullWidth
                  label="Nom"
                  size="medium"
                  error={fieldError && nomField === "" ? true : false}
                  helperText={fieldError && nomField === "" ? 'Le nom de famille est requis' : ''}
                  primaryColor={config?.color ? `#${config?.color?.primaryColor}` : null}
                  secondaryColor={config?.color ? `#${config?.color?.secondaryColor}` : null}
                  bgColor={config?.color ? `#${config?.color?.bgColor}` : null}
                  textColor={config?.color ? getContrastColor(config?.color?.bgColor) : null}
                />
                <CustomTextField
                  disabled={loading}
                  value={prenomField}
                  onChange={(e) => setPrenom(e.target.value)}
                  fullWidth
                  label="Prenom"
                  size="medium"
                  error={fieldError && prenomField === "" ? true : false}
                  helperText={fieldError && prenomField === "" ? "Le prénom est requis" : ''}
                  primaryColor={config?.color ? `#${config?.color?.primaryColor}` : null}
                  secondaryColor={config?.color ? `#${config?.color?.secondaryColor}` : null}
                  bgColor={config?.color ? `#${config?.color?.bgColor}` : null}
                  textColor={config?.color ? getContrastColor(config?.color?.bgColor) : null}
                />
              </Stack>
              <Stack direction={'row'} spacing={2}>
                <CustomTextField
                  disabled={loading || user}
                  type="email"
                  value={emailField}
                  onChange={(e) => setEmail(e.target.value)}
                  fullWidth
                  label="Email"
                  error={fieldError && emailField === "" ? true : false}
                  helperText={fieldError && emailField === "" ? "Veuillez saisir une adresse email valide" : ''}
                  size="medium"
                  primaryColor={config?.color ? `#${config?.color?.primaryColor}` : null}
                  secondaryColor={config?.color ? `#${config?.color?.secondaryColor}` : null}
                  bgColor={config?.color ? `#${config?.color?.bgColor}` : null}
                  textColor={config?.color ? getContrastColor(config?.color?.bgColor) : null}
                />
                {
                  !user && <CustomTextField
                    disabled={loading}
                    value={confirmEmailField}
                    onChange={(e) => setConfirmEmail(e.target.value)}
                    fullWidth
                    label="Confirmer l'email "
                    size="medium"
                    type="email"
                    error={fieldError && confirmEmailField === "" ? true : false}
                    helperText={fieldError && confirmEmailField === "" ? "Merci de remplir ce champs" : ''}
                    primaryColor={config?.color ? `#${config?.color?.primaryColor}` : null}
                    secondaryColor={config?.color ? `#${config?.color?.secondaryColor}` : null}
                    bgColor={config?.color ? `#${config?.color?.bgColor}` : null}
                    textColor={config?.color ? getContrastColor(config?.color?.bgColor) : null}
                  />
                }
              </Stack>
              <FormControlLabel
                control={<Checkbox defaultChecked />}
                label={<Typography color={`${config?.color != null ? `#${config?.color?.textColor}` : 'GrayText'}`} variant="body2">Tenez-moi au courant des autres événements et des nouvelles de cet organisateur.</Typography>}
              />

              <FormControlLabel
                control={<Checkbox defaultChecked />}
                label={<Typography color={`${config?.color != null ? `#${config?.color?.textColor}` : 'GrayText'}`} variant="body2">Envoyez-moi des e-mails sur les meilleurs événements ayant lieu dans mes environ ou en ligne.</Typography>}

              />
            </Stack>
            {/** Promo code */}
            <Stack>
              {
                addCode ?
                  <Stack spacing={1}
                    direction="row"
                    justifyContent="left" alignItems={'center'}>
                    {
                      codeCheck.valid ? <Typography sx={{ color: 'green' }} variant="caption">{codeCheck.message}</Typography> : !codeCheck.valid ? <Typography sx={{ color: 'red' }} variant="caption">{codeCheck.message}</Typography> : null
                    }
                    <TextField placeholder="Entrer votre code" label='Promo code' disabled={loading} size="medium" fullWidth value={discountField}
                      onChange={(e) => setDiscount(e.target.value)} />
                    <CustomButton disabled={loading} size="medium" type={'primaire'} buttonText={'Appliquer'} onClick={handleVerifyPromoCode} />
                  </Stack>
                  :
                  <Stack spacing={1}
                    direction="row"
                    justifyContent="left" alignItems={'center'}>
                    <Typography color={`${config?.color != null ? `#${config?.color?.textColor}` : 'GrayText'}`} variant="caption">Vous avez un code de réduction ?</Typography>
                    <Button
                      onClick={() => setAddCode(true)}
                      variant="text"
                      size="small"
                      sx={{
                        fontSize: 12,
                        textTransform: 'initial',
                        border: '2px solid transparent',
                        color: `${config?.color != null ? `#${config?.color?.primaryColor}` : '#5E17EB'}`,
                        backgroundColor: 'transparent',
                        borderRadius: '7px',
                        '&:hover': {
                          backgroundColor: 'transparent',
                          color: `${config?.color != null ? `#${config?.color?.primaryColor}` : '#5E17EB'}`,
                          borderColor: 'transparent',
                        },
                      }}
                    >
                      cliquez-ici
                    </Button>
                  </Stack>

              }
            </Stack>
            {/** Pay with */}

            {reduction && (montant - reduction.value) === 0 ? <></> : montant === 0 ? <></> :
              <Stack spacing={2}>
                <Typography fontSize={18}
                  fontWeight={500}>
                  Payer avec
                </Typography>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={moyenPaie}
                  name="radio-buttons-group"
                  onChange={(e) => {
                    handleRadioChange(e);
                  }}
                >
                  <Stack spacing={2}>
                    <Stack onClick={() => setPaymentWay(0)} sx={{ borderRadius: '10px', border: `1px solid ${config?.color != null ? `#${config?.color?.secondaryColor}` : 'gainsboro'}`, cursor: 'pointer' }} direction={'row'} spacing={1} justifyContent={'space-between'} alignItems={'center'} padding={1}>
                      <FormControlLabel sx={{ alignItems: 'center' }} value={0} control={<Radio />} label={<Stack justifyContent={'space-between'} direction={'row'} spacing={1}>
                        <Box sx={{ alignItems: 'center', display: 'flex' }}>Mobile Money & Wave</Box>
                      </Stack>} />
                      <Stack direction={'row'} spacing={1}>
                        <Box
                          component="img"
                          src={'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown.png?alt=media&token=58e2969c-a636-488e-b638-b27d0fec4459://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'}
                          onError={'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2Fpreview.png?alt=media&token=8580a57d-7522-4ee3-8335-efc4a1a9261a'}
                          loading="lazy"
                          decoding="async"
                          srcSet={`${'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown.png?alt=media&token=58e2969c-a636-488e-b638-b27d0fec4459://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'} 1x, ${'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown.png?alt=media&token=58e2969c-a636-488e-b638-b27d0fec4459://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'} 2x`}

                          sx={{
                            // aspectRatio: "16 / 9",
                            objectFit: "cover",
                            width: "35px",
                            height: "28px",
                            display: "block",
                            bgcolor: "#f2f2f2",
                            borderRadius: '5px',
                            transition: "opacity .3s ease",
                          }}
                        />
                        <Box
                          component="img"
                          src={'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-3.png?alt=media&token=9855e697-2621-47eb-8c52-b33b1fee8433://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'}
                          onError={'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2Fpreview.png?alt=media&token=8580a57d-7522-4ee3-8335-efc4a1a9261a'}
                          loading="lazy"
                          decoding="async"
                          srcSet={`${'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-3.png?alt=media&token=9855e697-2621-47eb-8c52-b33b1fee8433://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'} 1x, ${'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-3.png?alt=media&token=9855e697-2621-47eb-8c52-b33b1fee8433://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'} 2x`}

                          sx={{
                            // aspectRatio: "16 / 9",
                            objectFit: "cover",
                            width: "35px",
                            height: "28px",
                            display: "block",
                            borderRadius: '5px',
                            bgcolor: "#f2f2f2",
                            transition: "opacity .3s ease",
                          }}
                        />
                        <Box
                          component="img"
                          src={'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-2.png?alt=media&token=1143cc52-69d1-4509-b1a4-cc13a62eb97f://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'}
                          onError={'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2Fpreview.png?alt=media&token=8580a57d-7522-4ee3-8335-efc4a1a9261a'}
                          loading="lazy"
                          decoding="async"
                          srcSet={`${'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-2.png?alt=media&token=1143cc52-69d1-4509-b1a4-cc13a62eb97f://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'} 1x, ${'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-2.png?alt=media&token=1143cc52-69d1-4509-b1a4-cc13a62eb97f://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'} 2x`}

                          sx={{
                            // aspectRatio: "16 / 9",
                            objectFit: "cover",
                            width: "35px",
                            height: "28px",
                            display: "block",
                            borderRadius: '5px',
                            bgcolor: "#f2f2f2",
                            transition: "opacity .3s ease",
                          }}
                        />
                        <Box
                          component="img"
                          src={'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'}
                          onError={'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2Fpreview.png?alt=media&token=8580a57d-7522-4ee3-8335-efc4a1a9261a'}
                          loading="lazy"
                          decoding="async"
                          srcSet={`${'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'} 1x, ${'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'} 2x`}

                          sx={{
                            // aspectRatio: "16 / 9",
                            objectFit: "cover",
                            width: "35px",
                            height: "28px",
                            display: "block",
                            borderRadius: '5px',
                            bgcolor: "#f2f2f2",
                            transition: "opacity .3s ease",
                          }}
                        />
                      </Stack>

                    </Stack>
                    <Stack onClick={() => setPaymentWay(1)} sx={{ borderRadius: '10px', border: `1px solid ${config?.color != null ? `#${config?.color?.secondaryColor}` : 'gainsboro'}`, cursor: 'pointer' }} direction={'row'} spacing={1} justifyContent={'space-between'} alignItems={'center'} padding={1}>
                      <FormControlLabel sx={{ alignItems: 'center' }} value={1} control={<Radio />} label={<Stack justifyContent={'space-between'} direction={'row'} spacing={1}>
                        <Box sx={{ alignItems: 'center', display: 'flex' }}>Carte de débit ou de crédit</Box>
                      </Stack>} />
                      <Iconify
                        icon="bi:credit-card-2-back"
                        sx={{ width: 30, height: 30 }}
                      />
                    </Stack>
                    <Stack onClick={() => setPaymentWay(2)} sx={{ borderRadius: '10px', border: `1px solid ${config?.color != null ? `#${config?.color?.secondaryColor}` : 'gainsboro'}`, cursor: 'pointer' }} direction={'row'} spacing={1} justifyContent={'space-between'} alignItems={'center'} padding={1}>
                      <FormControlLabel sx={{ alignItems: 'center' }} value={2} control={<Radio />} label={<Stack justifyContent={'space-between'} direction={'row'} spacing={1}>
                        <Box sx={{ alignItems: 'center', display: 'flex' }}>PayPal</Box>
                      </Stack>} />
                      <Iconify
                        icon="logos:paypal"
                        sx={{ width: 30, height: 30 }}
                      />
                    </Stack>
                  </Stack>
                </RadioGroup>

              </Stack>}

            {/** payment bouton */}
            <Stack spacing={2}>

              <Stack direction="row" justifyContent="end" spacing={1}>
                <Stack
                  direction="row"
                  spacing={0.1}
                  onClick={() => {
                    handleOpenRecap();
                  }}
                >

                  <Iconify
                    icon="material-symbols-light:info-outline"
                    sx={{ width: 24, height: 24 }}
                  />
                </Stack>
                <Sheet isOpen={openRecap} onClose={() => setOpenRecap(false)} snapPoints={[400]}>
                  <Sheet.Container >
                    <Sheet.Header />
                    <Sheet.Content>
                      <Box sx={{ overflowX: "auto", overflowY: "auto", height: '100%' }}>

                        <Stack sx={{ height: '100%', display: 'flex' }}>
                          <Stack spacing={2} padding={2} sx={{ flexGrow: 1, display: 'flex' }}>

                            <Typography fontSize={18} fontWeight={500}>
                              Résumé de la commande
                            </Typography>
                            {ticketsList.map((billet, index) => (
                              <Box color="#999999">
                                <Stack
                                  direction="row"
                                  justifyContent="space-between"
                                >
                                  <Typography>
                                    {billet.quantite}x {billet.nom}
                                  </Typography>
                                  <Typography>{shortNumber(billet.prix)} CFA</Typography>
                                </Stack>
                              </Box>
                            ))}
                            <Divider />
                            {
                              (moyenPaie === 1 || moyenPaie === 2 || reduction) &&
                              <>
                                <Stack direction="row" justifyContent="space-between">
                                  <Typography color="#999999">Sous-total</Typography>
                                  <Typography color="#999999">{shortNumber(montant)} CFA</Typography>
                                </Stack>
                                {(moyenPaie === 1 || moyenPaie === 2) && (
                                  <>

                                    <Stack direction="row" justifyContent="space-between">
                                      <Typography color="#999999">Frais</Typography>
                                      <Typography color="#999999">{reduction ? shortNumber((montant - reduction.value) * fee / 100) : shortNumber(montant * fee / 100)} CFA</Typography>
                                    </Stack>
                                  </>

                                )}

                                {reduction && (
                                  <Stack color="#999999" direction="row" justifyContent="space-between">
                                    <Typography>Réduction</Typography>
                                    <Typography>
                                      {shortNumber(reduction.value)} CFA
                                    </Typography>
                                  </Stack>
                                )}
                                <Divider />
                              </>
                            }


                            <Stack direction="row" justifyContent="space-between">
                              <Typography fontSize={19} fontWeight={500}>Total à payer</Typography>
                              <Typography fontSize={19} fontWeight={500}>
                                {reduction
                                  ? shortNumber(montant - reduction.value + ((montant - reduction.value) * fee / 100))
                                  : shortNumber(montant + (montant * fee / 100))}
                                {' '}CFA
                              </Typography>
                            </Stack>

                            {/* 🟩 L'élément qui prend toute la hauteur restante */}
                            <Box sx={{ bgcolor: 'green', flexGrow: 1 }} />
                          </Stack>
                          <Box sx={{ height: '100%', alignItems: 'end', justifyContent: 'center', display: 'flex', padding: 2 }}>
                            <CustomButton fullWidth disabled={loading} type={'secondaire'} buttonText={'Fermer'} onClick={() => setOpenRecap(false)} />
                          </Box>

                        </Stack>

                      </Box>
                    </Sheet.Content>
                  </Sheet.Container>
                  <Sheet.Backdrop />
                </Sheet>
                <Typography
                  fontSize={17}
                  fontWeight={500}
                  align="center"
                  paddingBottom={1}
                >
                  {reduction ? shortNumber(montant - reduction.value + ((montant - reduction.value) * fee / 100)) : shortNumber(montant + (montant * fee / 100))} CFA
                </Typography>

              </Stack>
              <Typography variant="body2" color={`${config?.color != null ? `#${config?.color?.textColor}` : 'GrayText'}`}>En sélectionnant Commander, j'accepte les Conditions générales du service de choptonticket</Typography>
              <CustomButton fullWidth loading={loading || procedCheckCP} disabled={loading || procedCheckCP} type={'primaire'} buttonText={'Comfirmer la commande'} onClick={payV2} sx={{
                bgcolor: `${config?.color != null ? `#${config?.color?.primaryColor}` : null}`, borderRadius: `${config?.shape === 'square' ? `0px` : '7px'}`, color: `${getContrastColor(`${config?.color != null ? `#${config?.color?.primaryColor}` : '#5E17EB'}`)}`, '&:hover': {
                  backgroundColor: `${config?.color != null ? `${hexToRgba(config?.color?.primaryColor, 0.5)}` : null}`,
                  color: `${getContrastColor(`${config?.color != null ? `#${config?.color?.primaryColor}` : '#5E17EB'}`)}`,
                  borderColor: `${config?.color != null ? `${hexToRgba(config?.color?.primaryColor, 0.5)}` : null}`,
                },
              }} />
            </Stack>
            <Stack spacing={2}>
              <Divider />
              <Typography variant="caption" color={`${config?.color != null ? `#${config?.color?.textColor}` : 'GrayText'}`}>Realise par <strong>Choptonticket</strong></Typography>
            </Stack>
          </Stack>

        </Box>
      )}
    </Box>
  );
}
